
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conjure/policies/privacy-policy",
      function () {
        return require("private-next-pages/conjure/policies/privacy-policy.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/conjure/policies/privacy-policy"])
      });
    }
  